import { useState } from 'react'
import { ChevronDown, Leaf } from 'lucide-react'
import './CropSelector.css'

const CROPS = [
    { id: 'arroz', name: 'Arroz', emoji: '🌾' },
    { id: 'arandanos', name: 'Arándanos', emoji: '🫐' },
    { id: 'maiz', name: 'Maíz', emoji: '🌽' },
    { id: 'tomate', name: 'Tomate', emoji: '🍅' },
    { id: 'gulupa', name: 'Gulupa', emoji: '🍇' },
]

function CropSelector({ selectedCrop, onSelectCrop }) {
    const [isOpen, setIsOpen] = useState(false)

    const handleSelect = (crop) => {
        onSelectCrop(crop.name)
        setIsOpen(false)
    }

    const selectedCropData = CROPS.find(c => c.name === selectedCrop)

    return (
        <div className="crop-selector">
            <label className="selector-label">Cultivo Activo</label>
            <button
                className="selector-button"
                onClick={() => setIsOpen(!isOpen)}
            >
                {selectedCropData ? (
                    <>
                        <span className="crop-emoji">{selectedCropData.emoji}</span>
                        <span className="crop-name">{selectedCropData.name}</span>
                    </>
                ) : (
                    <>
                        <Leaf size={18} />
                        <span>Seleccionar cultivo</span>
                    </>
                )}
                <ChevronDown size={18} className={`chevron ${isOpen ? 'open' : ''}`} />
            </button>

            {isOpen && (
                <div className="selector-dropdown">
                    {CROPS.map((crop) => (
                        <button
                            key={crop.id}
                            className={`dropdown-item ${selectedCrop === crop.name ? 'active' : ''}`}
                            onClick={() => handleSelect(crop)}
                        >
                            <span className="crop-emoji">{crop.emoji}</span>
                            <span className="crop-name">{crop.name}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    )
}

export default CropSelector
